// Navy/gold curved edge inspired by the Save-the-Date artwork. Purely decorative.
export const Swoosh = ({ fill = "#FFFFFF", className = "" }) => (
  <svg viewBox="0 0 1440 90" preserveAspectRatio="none" aria-hidden="true" focusable="false"
    className={`pointer-events-none absolute inset-x-0 bottom-0 h-10 w-full sm:h-14 ${className}`}>
    <path d="M0 90V58C300 18 760 0 1440 46V90Z" fill={fill} />
    <path d="M0 58C300 18 760 0 1440 46" fill="none" stroke="var(--gold)" strokeWidth="3" vectorEffect="non-scaling-stroke" />
  </svg>
);

export const GoldRule = ({ children, className = "", light = false, testid }) => (
  <p className={`gold-rule ${light ? "text-white" : "text-navy"} ${className}`} data-testid={testid}>
    <span aria-hidden="true" className="gold-rule-line" />
    <span>{children}</span>
    <span aria-hidden="true" className="gold-rule-line" />
  </p>
);
